import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isNativePlatform } from './runtime';

/** Light selection tap — recommendation answers, tab changes. */
export async function hapticSelection(): Promise<void> {
  if (!isNativePlatform()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    // web / unsupported
  }
}

/** Success after watchlist / watched add confirmed by server. */
export async function hapticSuccess(): Promise<void> {
  if (!isNativePlatform()) return;
  try {
    await Haptics.notification({ type: NotificationType.Success });
  } catch {
    // web / unsupported
  }
}

/** Warning before destructive delete — use sparingly. */
export async function hapticWarning(): Promise<void> {
  if (!isNativePlatform()) return;
  try {
    await Haptics.notification({ type: NotificationType.Warning });
  } catch {
    // web / unsupported
  }
}
